<template>

    <div v-if="isLoading" class="loading-overlay">
        <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Cargando...</span>
        </div>
    </div>


    <div class="row">

        <div class="col-xl-12 d-flex">
            <div class="card flex-fill">
                <div class="card-header">
                    <h5 class="card-title">Actualizar Producto</h5>
                </div>
                <div class="card-body card-buttons">
                    <form class="needs-validation" novalidate>
                        <div class="row">

                            <div class="col-12 col-lg-9">
                                <div class="row">
                                    <div class="col-12 mt-2 input-block">
                                        <label for="name">Nombre</label>
                                        <b-form-input type="text" v-model="product.titulo" id="name"
                                            class="form-control" />
                                    </div>

                                    <div class="col-12 col-sm-6 mt-2 input-block">
                                        <label>Categoria</label>
                                        <select v-model="product.categoriaId" @change="init_subCategory($event)"
                                            class="form-control">
                                            <option value="" disabled>Selecciona una categoría</option>
                                            <option v-for="category in categories" :key="category.id"
                                                :value="category.id">
                                                {{ category.nombre }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-12 col-sm-6 mt-2 input-block">
                                        <label>Sub Categoria</label>
                                        <select v-model="product.subCategoriaId" class="form-control">
                                            <option value="" disabled>Selecciona una Sub Categoría</option>
                                            <option v-for="subCategory in subCategories" :key="subCategory.id"
                                                :value="subCategory.id">
                                                {{ subCategory.nombre }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="col-4 col-sm-4 mt-2 input-block">
                                        <label for="costo">Costo</label>
                                        <b-form-input type="number" v-model="product.costo" id="costo"
                                            @keyup="calculatePrice()" class="form-control" />
                                    </div>

                                    <div class="col-4 col-sm-4 mt-2 input-block">
                                        <label for="porcentaje_ganancia">Porcentaje Ganancia
                                            %</label>
                                        <b-form-input type="number" v-model="product.porcentaje_ganancia"
                                            @keyup="calculatePrice()" id="porcentaje_ganancia" class="form-control" />
                                    </div>

                                    <div class="col-4 col-sm-4 mt-2 input-block">
                                        <label for="precio">Precio</label>
                                        <b-form-input type="number" v-model="product.precio" id="precio"
                                            class="form-control" />
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-lg-3 mt-2 input-block">
                                <label>Imagen de portada</label>
                                <input class="form-control" type="file" @change="handleImageUpload" accept="image/*" />
                                <div class="mt-1 text-center">
                                    <img :src="imagePreview" alt="Vista previa de la imagen" class="img-thumbnail"
                                        style="max-width: 200px; max-height: 200px;" />
                                </div>
                            </div>



                            <div class="col-12 mt-2 input-block">
                                <label for="precio">Extracto</label>
                                <textarea class="form-control" id="" rows="3" placeholder="Extracto"
                                    v-model="product.extracto"></textarea>
                            </div>

                            <div class="col-12 col-sm-6 mt-2 input-block">
                                <div class="active-switch">
                                    <label for="descuento">Descuento</label>
                                    <div class="status-toggle">
                                        <input id="descuento" class="check" type="checkbox"
                                            v-model="product.descuento" />
                                        <label for="descuento" class="checktoggle checkbox-bg"></label>
                                    </div>
                                    <small class="form-text text-primary small-lg" v-if="product.descuento">
                                        El precio con descuento será visible para los clientes. Verifica que sea
                                        correcto.
                                    </small>
                                    <small class="form-text text-primary small-lg" v-else>
                                        El descuento está desactivado. Los clientes verán el precio regular.
                                    </small>
                                </div>
                                <div class="mt-2" v-if="product.descuento">
                                    <label for="precio_oferta">Precio de Oferta</label>
                                    <b-form-input type="number" v-model="product.precio_oferta" id="precio_oferta"
                                        class="form-control" />
                                </div>
                            </div>

                            <div class="col-12 col-sm-6 mt-2 input-block">
                                <div class="active-switch">
                                    <label for="precio">Publicar</label>
                                    <div class="status-toggle">
                                        <input id="estado" class="check" type="checkbox" v-model="product.estado" />
                                        <label for="estado" class="checktoggle checkbox-bg"></label>
                                    </div>
                                    <small class="form-text text-primary small-lg">
                                        Cuando activas esta opción, el artículo se publica automáticamente en la web.
                                        Desactívalo si quieres guardarlo como borrador para editar más tarde.
                                    </small>
                                </div>
                            </div>

                            <div class="text-end mt-3">
                                <b-button @click="submitForm" class="btn-primary m-1">
                                    Actualizar
                                </b-button>
                            </div>

                            <h2 class="mb-2">Variedades de producto</h2>

                            <div class="col-12 col-sm-4 mt-4 input-block">
                                <div class="active-switch">
                                    <label for="talla">¿Maneja tallas?</label>
                                    <div class="status-toggle">
                                        <input id="talla" class="check" type="checkbox" v-model="product.talla" />
                                        <label for="talla" class="checktoggle checkbox-bg"></label>
                                    </div>
                                    <small class="form-text text-primary small-lg" v-if="product.talla">
                                        Este producto tiene diferentes tallas (selección requerida al agregar al
                                        carrito)
                                    </small>
                                    <small class="form-text text-muted small-lg" v-else>
                                        Este producto no maneja tallas
                                    </small>
                                </div>
                            </div>

                            <div class="col-12 col-sm-4 mt-4 input-block">
                                <div class="active-switch">
                                    <label for="medida">¿Maneja medidas?</label> <!-- Cambiado a "medidas" -->
                                    <div class="status-toggle">
                                        <input id="medida" class="check" type="checkbox" v-model="product.medida" />
                                        <label for="medida" class="checktoggle checkbox-bg"></label>
                                    </div>
                                    <small class="form-text text-primary small-lg" v-if="product.medida">
                                        Este producto requiere medidas personalizadas (ej: ancho, alto, largo).
                                    </small>
                                    <small class="form-text text-muted small-lg" v-else>
                                        Este producto no requiere medidas adicionales.
                                    </small>
                                </div>
                            </div>

                            <div class="col-12 col-sm-4 mt-4 input-block">
                                <div class="active-switch">
                                    <label for="color">¿Maneja colores?</label>
                                    <div class="status-toggle">
                                        <input id="color" class="check" type="checkbox" v-model="product.color" />
                                        <label for="color" class="checktoggle checkbox-bg"></label>
                                    </div>
                                    <small class="form-text text-primary small-lg" v-if="product.color">
                                        Este producto tiene variantes de color (selección requerida al agregar al
                                        carrito)
                                    </small>
                                    <small class="form-text text-muted small-lg" v-else>
                                        Este producto no tiene opciones de color (color único).
                                    </small>
                                </div>
                            </div>

                            <div class="col-12 col-sm-4 mt-2 input-block">
                                <label for="talla2" v-if="product.talla">Talla</label>
                                <b-form-input v-if="product.talla" type="text" v-model="variedad.talla" id="talla2"
                                    class="form-control" />
                            </div>

                            <div class="col-12 col-sm-4 mt-2 input-block">
                                <label for="medida2" v-if="product.medida">Medida</label>
                                <b-form-input v-if="product.medida" type="text" v-model="variedad.medida" id="medida2"
                                    class="form-control" />
                            </div>

                            <div class="col-12 col-sm-4 mt-2 input-block">
                                <label for="color2" v-if="product.color">Color</label>
                                <b-form-input v-if="product.color" type="text" v-model="variedad.color" id="color2"
                                    class="form-control" />
                            </div>

                            <div class="col-12 mt-2 input-block">
                                <b-button class="btn-primary w-100" @click="saveVariedad">
                                    Agregar Variedad
                                </b-button>
                            </div>


                            <div class="table-responsive mt-4">
                                <table class="table table-stripped table-hover">
                                    <thead>
                                        <tr>
                                            <th></th>
                                            <th>Talla</th>
                                            <th>Medida</th>
                                            <th>Color</th>
                                            <th>Can.</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="variedad in variedades" :key="variedad.id">
                                            <td>{{ variedad.sku }}</td>
                                            <td>{{ variedad.talla }}</td>
                                            <td>{{ variedad.medida }}</td>
                                            <td>{{ variedad.color }}</td>
                                            <td>{{ variedad.stock }}</td>
                                            <td class="text-end">
                                                <a href="#" @click.prevent="deleteVariedad(variedad)"
                                                    class="btn btn-sm btn-light-danger" title="Eliminar Valiedad"
                                                    data-bs-toggle="tooltip">
                                                    <i class="fas fa-trash"></i>
                                                </a>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>


                        </div>


                    </form>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import api from '@/api';
import user5 from '@/assets/img/user-5.jpg';

export default {

    data() {
        return {
            isLoading: false,
            product: {
                titulo: '',
                categoriaId: '',
                subCategoriaId: '',
                precio: 0,
                costo: 0,
                porcentaje_ganancia: 0,
                extracto: '',
                talla: false,
                color: false,
                medida: false,
                estado: true,
                descuento: false,
                precio_oferta: 0,
                portada: undefined
            },
            categories: [],
            subCategories: [],
            subCategoriesAll: [],
            baseURL: api.defaults.baseURL,
            imagePreview: user5,
            selectedImage: null,

            variedad: {},
            variedades: [],

            productId: this.$route.params.id,
        };
    },
    mounted() {
        this.getProductId();
        this.loadCategories();
        this.loadSubCategories();
        this.loadVariedads();
    },

    methods: {
        async loadCategories() {
            try {
                const response = await api.get('/categoria');
                this.categories = response.data;
            } catch (err) {
                this.error = 'Error al cargar categorías';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        async loadSubCategories() {
            try {
                const response = await api.get('/sub_categoria');
                this.subCategories = response.data;
                this.subCategoriesAll = response.data;
            } catch (err) {
                this.error = 'Error al cargar sub-categorías';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        async loadVariedads() {
            try {
                const response = await api.get(`/variedad/${this.productId}`);
                this.variedades = response.data;
                console.log(response.data);
            } catch (err) {
                this.error = 'Error al cargar sub-categorías';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        async getProductId() {
            try {
                const response = await api.get(`/producto/obtener/${this.productId}`);
                this.product = response.data;
                const nombreArchivo = this.product.portada.split('/').pop();
                this.imagePreview = this.baseURL + '/producto/obtener_image_producto/' + nombreArchivo;
            } catch (err) {
                this.error = 'Error al cargar sub-categorías';
                console.error(err);
            } finally {
                this.isLoading = false;
            }
        },
        init_subCategory(event) {
            let id_category = event.target.value;

            let subcat;

            subcat = this.subCategoriesAll.filter(cat => cat.categoriaId == id_category);
            this.subCategories = subcat;
        },
        calculatePrice() {
            let costo = parseInt(this.product.costo);
            let porcen = parseInt(this.product.porcentaje_ganancia);
            let precio;

            precio = costo + (costo * (porcen / 100));

            this.product.precio = precio;
        },
        handleImageUpload(event) {
            const file = event.target.files[0];

            if (file) {
                this.selectedImage = file;

                const reader = new FileReader();
                reader.onload = (e) => {
                    this.imagePreview = e.target.result;
                };
                reader.readAsDataURL(file);
            } else {
                this.imagePreview = null;
                this.selectedImage = null;
            }
        },
        async submitForm() {

            const result = await this.$swal.fire({
                title: '¿Guardar categoría?',
                text: 'Se guardará un nuevo producto.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Sí, guardar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;
            this.isLoading = true;

            const formData = new FormData();
            if (this.selectedImage) {
                formData.append("portada", this.selectedImage);
            }
            formData.append("titulo", this.product.titulo);
            formData.append("categoriaId", this.product.categoriaId);
            formData.append("subCategoriaId", this.product.subCategoriaId);
            formData.append("precio", this.product.precio);
            formData.append("costo", this.product.costo);
            formData.append("porcentaje_ganancia", this.product.porcentaje_ganancia);
            formData.append("extracto", this.product.extracto);
            formData.append("estado", this.product.estado);
            formData.append("talla", this.product.talla);
            formData.append("descuento", this.product.descuento);
            formData.append("precio_oferta", this.product.precio_oferta);
            formData.append("color", this.product.color);
            formData.append("medida", this.product.medida);

            try {
                const response = await api.put(`/producto/uptade/${this.productId}`, formData);
                this.isLoading = false;
                this.$toast.success('Producto agregada con éxito');
            } catch (error) {
                this.isLoading = false;
                this.$toast.error('Error al agregada el Producto');
            }
        },
        resetForm() {
            this.variedad = {
                talla: '',
                color: '',
                medida: '',
            };
        },
        generarSKU() {
            // Extrae las primeras letras del título (en mayúsculas, sin espacios)
            const tituloPart = this.product.titulo
                ? this.product.titulo.replace(/\s+/g, '').substr(0, 3).toUpperCase()
                : 'PRO';

            let skuParts = [tituloPart];

            if (this.variedad.talla) {
                skuParts.push(this.variedad.talla.toString().substr(0, 3).toUpperCase());
            }
            if (this.variedad.color) {
                skuParts.push(this.variedad.color.toString().substr(0, 3).toUpperCase());
            }
            if (this.variedad.medida) {
                skuParts.push(this.variedad.medida.toString().substr(0, 3).toUpperCase());
            }

            const sku = skuParts.join('-');

            return sku;
        },
        async saveVariedad() {
            let data = {
                talla: this.variedad.talla,
                color: this.variedad.color,
                medida: this.variedad.medida,
                sku: this.generarSKU(),
                stock: 0,
                productoId: Number(this.productId)
            }

            try {
                const response = await api.post("/variedad", data);
                this.loadVariedads();
            } catch (error) {
                console.log(error)
                this.$toast.error('Error al agregada la variedad');
            }
        },
        async deleteVariedad(variedad) {

            const result = await this.$swal.fire({
                title: '¿Eliminar Variedad?',
                text: 'Esta acción no se puede deshacer.',
                icon: 'error',
                showCancelButton: true,
                confirmButtonText: 'Sí, eliminar',
                cancelButtonText: 'Cancelar'
            });

            if (!result.isConfirmed) return;

            try {
                const response = await api.delete(`/variedad/${variedad.id}`);
                this.$toast.success('Variedad eliminada con éxito');
                this.loadVariedads();
            } catch (error) {
                this.$toast.error(error.response.data.msg);
                console.error("Error:", error);
            }
        }
    },
    computed: {
        calcularTotal() {
            return this.variedades.reduce((total, variedad) => total + parseInt(variedad.stock || 0), 0);
        }
    }

};
</script>

<style>
td {
    cursor: pointer;
    transition: background-color 0.2s;
}

.is-invalid {
    border-color: #dc3545;
}

thead tr th {
    background-color: #7539FF !important;
    color: white !important;
}

.loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1050;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(2px);
}

.small-lg {
    font-size: 0.9rem !important;
}

.actions {
    white-space: nowrap;
}

.actions .btn {
    padding: 0.35rem 0.5rem;
    font-size: 0.875rem;
}
</style>
